<script>
  import { _ } from "./i18n.js";
  import { onMount, onDestroy, setContext } from "svelte";
  import { f7 } from "framework7-svelte";
  import { map } from "./stores.js";
  import { initMapService } from "./MapService.js";
  import GeoControl from "./GeoControl.js";

  export let sheet;
  export let deliverable;
  export let deliveryLocation;
  let deliveryLocationUnsubscribe;

  let container;
  let zoom = 16;
  let locationMarker;
  let myLocationMarker;

  onMount(async () => {
    initMapService(() => showMap());

    deliveryLocationUnsubscribe = deliveryLocation.subscribe(value => {
      if (value) {
        if (locationMarker) {
          locationMarker.setPosition(
            new google.maps.LatLng(value.lat, value.lng)
          );
        }

        if (sheet && value.showInfo) {
          sheet.open();
        }
      }
    });
  });

  onDestroy(async () => {
    deliveryLocationUnsubscribe && deliveryLocationUnsubscribe();
  });

  function showMap() {
    map.set(
      new google.maps.Map(container, {
        zoom,
        center: $deliveryLocation
          ? { lat: $deliveryLocation.lat, lng: $deliveryLocation.lng }
          : null
      })
    );

    locationMarker = new google.maps.Marker({
      position: $deliveryLocation || null,
      map: $map,
      draggable: true,
      title: $_("orderNew.deliveryLocation"),
      zIndex: 1
    });

    var icon = {
      url: "/myLocation.png",
      scaledSize: new google.maps.Size(50, 50),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 25)
    };

    myLocationMarker = new google.maps.Marker({
      map: $map,
      draggable: false,
      icon: icon,
      zIndex: 0
    });

    let geoControlDiv = document.createElement("div");
    geoControlDiv.index = 1;

    let findYourLocationCallback = function(pos) {
      if (pos) {
        let latLng = new google.maps.LatLng({
          lat: pos.lat,
          lng: pos.lng
        });
        locationMarker.setPosition(latLng);
        myLocationMarker.setPosition(latLng);
        $map.panTo({
          lat: pos.lat,
          lng: pos.lng
        });
        markerMoved(latLng);
      }
    };

    var geoControl = new GeoControl(geoControlDiv, $map);
    geoControl.addClickListener(findYourLocationCallback);
    $map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(geoControlDiv);

    var infowindow = new google.maps.InfoWindow({
      content: $_("order.map.dragTheMarker")
    });

    locationMarker.addListener("click", function(event) {
      infowindow.open($map, locationMarker);
    });

    locationMarker.addListener("dragend", function(e) {
      markerMoved(e.latLng);
    });

    fetch("/krabi.geojson")
      .then(res => res.json())
      .then(json => {
        let polygonArray = [];
        let worldCoords = [
          { lat: -85.1054596961173, lng: -180 },
          { lat: 85.1054596961173, lng: -180 },
          { lat: 85.1054596961173, lng: 180 },
          { lat: -85.1054596961173, lng: 180 },
          { lat: -85.1054596961173, lng: 0 }
        ];
        polygonArray.push(worldCoords);
        polygonArray = polygonArray.concat(unionPolygons(json));
        $map.data.add({
          geometry: new google.maps.Data.Polygon(polygonArray)
        });
        $map.data.addGeoJson(json);
        $map.data.addListener("click", function(e) {
          locationMarker.setPosition(e.latLng);
          markerMoved(e.latLng);
        });
        $map.data.setStyle(function(feature) {
          let deliverable = feature.getProperty("deliverable");
          let color;
          if (deliverable === undefined) {
            color = "black";
          } else {
            color = deliverable ? "green" : "red";
          }

          return {
            fillColor: color,
            fillOpacity: 0.15,
            strokeWeight: 1,
            strokeOpacity: 0.1
          };
        });

        if (!$deliveryLocation) {
          geoControl.findYourLocation(function(pos) {
            if (!pos) {
              let pos = { lat: 8.053517, lng: 98.916551 };
              let latLng = new google.maps.LatLng({
                lat: pos.lat,
                lng: pos.lng
              });
              markerMoved(latLng);
              $map.panTo(pos);
            } else {
              findYourLocationCallback(pos);
            }
          });
        }

        infowindow.open($map, locationMarker);
      });
  }

  function markerMoved(latLng) {
    let isDeliverable = false;
    $map.data.forEach(function(feature) {
      if (feature.getGeometry().getType() === "Polygon") {
        var poly = new google.maps.Polygon({
          path: feature
            .getGeometry()
            .getAt(0)
            .getArray()
        });
        if (google.maps.geometry.poly.containsLocation(latLng, poly)) {
          isDeliverable = feature.getProperty("deliverable");
        }
      }
    });

    deliverable.set(isDeliverable);

    let pos = {
      lat: latLng.lat(),
      lng: latLng.lng(),
      showInfo: true,
      checkLocation: true
    };
    deliveryLocation.set(pos);
  }

  function unionPolygons(json) {
    let polygonArray = [];
    json.features.forEach(function(feature) {
      let polygons = [];
      feature.geometry.coordinates[0].forEach(function(coordinate) {
        polygons.push({ lat: coordinate[1], lng: coordinate[0] });
      });
      polygonArray.push(polygons.reverse());
    });

    return polygonArray;
  }
</script>

<style>
  .full-screen {
    width: 100%;
    height: 100%;
  }
</style>

<div class="full-screen" bind:this={container} />
